'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'icons';
var width = 576;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = 'M544-5.3l0 177.8c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c19.1 0 36.3 6.3 48 16.3l0-126.5-144 28.8 0 177.4c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c19.1 0 36.3 6.3 48 16.3l0-158.8 6.4-1.3 160-32 9.6-1.9zM515.7 151.4c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9-12.3 14.1-12.3 21.1 3.8 14.7 12.3 21.1 21.1 10.9 35.7 10.9 27.1-4.4 35.7-10.9 12.3-14.1 12.3-21.1l0 0c0-7.1-3.8-14.7-12.3-21.1zm-160 48c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9-12.3 14.1-12.3 21.1 3.8 14.7 12.3 21.1 21.1 10.9 35.7 10.9 27.1-4.4 35.7-10.9 12.3-14.1 12.3-21.1l0 0c0-7.1-3.8-14.7-12.3-21.1zM147.2 46.2l-7.3-9.8C130.2 23.6 115.1 16 99 16 70.9 16 48 38.9 48 67l0 6.1c0 13.7 6.1 28.8 17.1 44.5 10.9 15.6 25.9 30.6 41.3 43.9 15.4 13.2 30.8 24.2 42.5 32 4.3 2.9 8.1 5.3 11.1 7.2 3-1.9 6.8-4.3 11.1-7.2 11.6-7.8 27.1-18.8 42.5-32 15.4-13.2 30.4-28.2 41.3-43.9 11-15.8 17.1-30.8 17.1-44.5l0-6.1c0-28.2-22.9-51-51-51-16.1 0-31.2 7.6-40.8 20.4l0 0c-4 5.3-10.7 14.2-20.1 26.8L147.2 46.2zm20.1-19.4c.9-1.2 1.8-2.3 2.8-3.5 12.7-14.8 31.2-23.4 50.9-23.4 37 0 67 30 67 67l0 6.1c0 73.1-128 146.3-128 146.3S32 146.3 32 73.1L32 67c0-37 30-67 67-67 19.6 0 38.2 8.6 50.9 23.4 1 1.1 1.9 2.3 2.8 3.5l7.3 9.8 7.3-9.8zM304 304l16 0 0 208-288 0 0-208 74.7 0 21.3-32 96 0 21.3 32 58.7 0zm0 16l-67.2 0c-1.2-1.8-8.3-12.5-21.3-32l-78.9 0c-13 19.5-20.1 30.2-21.3 32l-67.2 0 0 176 256 0 0-176zM176 360a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm56 40a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm256.8-48l-5.6 16 68.8 0-18.4 16-141.2 122.8-24.4 21.2c4.1-11.8 17.2-49.1 39.2-112l5.6-16-68.8 0 18.4-16 141.2-122.8 24.4-21.2c-4.1 11.8-17.2 49.1-39.2 112zm20.4 32l-48.6 0c2.1-5.9 12.8-36.7 32.3-92.3l-106.2 92.3 48.6 0c-2.1 5.9-12.8 36.7-32.3 92.3L509.2 384z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;